export default __webpack_public_path__ + "images/0x7238390d5f6f64e67c3211c343a410e2a3dec142.png";